import TariffHistory from './TariffHistoryContainer';

export { TariffHistory };



// WEBPACK FOOTER //
// ./src/modules/home/tariffHistory/index.js